
<div class="spinner-div" style="overflow:hidden;">
  <mat-spinner style="padding: 0px;"></mat-spinner>
</div>
